"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
const Lines = _ref => {
  let {
    lines = [],
    onMouseOver = () => {},
    onMouseMove = () => {},
    onMouseOut = () => {},
    onClick = () => {}
  } = _ref;
  const fixedLines = lines.map((_ref2, i) => {
    let {
      cap = 'round',
      clipPath,
      color,
      cursor,
      endMarker,
      id,
      opacity = 1,
      style = 'solid',
      weight = 4,
      ...restOfLine
    } = _ref2;
    let strokeDasharray = '0 0';
    if (style === 'dot') {
      strokeDasharray = `1 ${weight * 2}`;
    } else if (style === 'dash') {
      strokeDasharray = `${weight * 2} ${weight * 2}`;
    }
    return {
      ...restOfLine,
      cap,
      clipPath,
      color: colors_1.COLOR_PALETTE[color] || color || colors_1.DEFAULT_COLORS[i],
      cursor: 'pointer',
      endMarkerX: endMarker ? endMarker.x : 0,
      endMarkerY: endMarker ? endMarker.y : 0,
      endMarkerColor: endMarker ? endMarker.color : '',
      endMarkerWeight: endMarker ? endMarker.weight : 0,
      key: id,
      opacity,
      strokeDasharray,
      weight
    };
  });
  return react_1.default.createElement("g", {
    className: "lines"
  }, fixedLines.map((line, i) => {
    const uniqueId = lodash_1.default.uniqueId(`${line.key}_mask_`);
    return react_1.default.createElement("g", {
      key: uniqueId
    }, line.clipPath && react_1.default.createElement("clipPath", {
      id: uniqueId
    }, react_1.default.createElement("path", {
      strokeWidth: 0,
      d: line.clipPath
    })), react_1.default.createElement("path", {
      className: "renderedPath",
      key: line.key,
      fill: "none",
      stroke: line.color,
      strokeWidth: line.weight,
      strokeLinecap: line.cap,
      strokeLinejoin: "round",
      strokeDasharray: line.strokeDasharray,
      clipPath: `url(#${uniqueId})`,
      d: line.line,
      style: {
        opacity: line.opacity,
        cursor: line.cursor
      },
      onMouseOver: event => onMouseOver(event, i),
      onMouseMove: event => onMouseMove(event, i),
      onMouseOut: event => onMouseOut(event, i),
      onClick: event => onClick(event, i)
    }), line.endMarkerX && line.endMarkerY ? react_1.default.createElement("circle", {
      cx: line.endMarkerX,
      cy: line.endMarkerY,
      r: line.endMarkerWeight,
      fill: line.endMarkerColor,
      pointerEvents: "none",
      opacity: line.opacity
    }) : null);
  }));
};
Lines.propTypes = {
  /** chart data */
  lines: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    cap: (0, prop_types_1.oneOf)(['butt', 'round', 'square']),
    clipPath: prop_types_1.string,
    color: prop_types_1.string,
    cursor: prop_types_1.string,
    durationMultiplier: prop_types_1.number,
    endMarker: (0, prop_types_1.shape)({
      color: prop_types_1.string.isRequired,
      x: prop_types_1.number.isRequired,
      y: prop_types_1.number.isRequired
    }),
    id: prop_types_1.string.isRequired,
    line: prop_types_1.string.isRequired,
    opacity: prop_types_1.number,
    style: (0, prop_types_1.oneOf)(['solid', 'dot', 'dash']),
    weight: prop_types_1.number
  })).isRequired,
  /**
   * function to activate on mouseOver
   * parameters: (event, index)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseMove
   * parameters: (event, index)
   */
  onMouseMove: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, index)
   */
  onMouseOut: prop_types_1.func,
  /**
   * function to activate on click
   * parameters: (event, index)
   */
  onClick: prop_types_1.func
};
exports.default = Lines;